<template lang='pug'>
//- 會員登入區塊
div(:class='$style[`cc-popbox-drugDetail`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme(v-html='`藥`')
        span.font-normal-theme(v-html='`品`')
        span.no-wrap(v-html='`資料`')

    div(:class='$style[`cc-content-wrap`]')
      ul(:class='$style[`cc-banner-wrap-ul`]')
        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 健保代碼
          span(:class='$style[`cc-banner-list-info`]') {{ detail.medId }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 製藥廠商
          span(:class='$style[`cc-banner-list-info`]') {{ detail.manufacturer }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 中文名稱
          span(:class='$style[`cc-banner-list-info`]') {{ detail.cnName }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 英文名稱
          span(:class='$style[`cc-banner-list-info`]') {{ detail.enName }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 主要成分
          span(:class='$style[`cc-banner-list-info`]') {{ detail.ingredient }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 藥品類型
          span(:class='$style[`cc-banner-list-info`]') {{ detail.medType }}

        li(:class='$style[`cc-banner-wrap-list`]')
          span(:class='$style[`cc-banner-list-title`]') 使用期限
          span(:class='$style[`cc-banner-list-info`]') {{ detail.period }}


</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },

  // data() {
  //   return {
  //   }
  // },

  methods: {
    ...mapMutations({
      changePopDrugStatus: 'global/POPDRUG_STATUS',
    }),

    handleClosePopBox() {
      this.changePopDrugStatus({
        active: false,
        detail: {},
      });
    },
  },

  // computed: {
  //   ...mapGetters({
  //     popBoxStatus: 'global/exportPopBoxStatus',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popDrugDetail.scss';
</style>
